<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "ProductionActionLaout"
    }
</script>

<style scoped>

</style>